module.exports = __webpack_public_path__ + "img/sw.2ceabc2a.png";